import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddDocumentIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_7093_470184)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M17.1333 0.5H3.93333C3.15536 0.5 2.40926 0.809047 1.85915 1.35915C1.30905 1.90926 1 2.65537 1 3.43333L1 22.0333C1 22.4223 1.15452 22.7954 1.42958 23.0704C1.70463 23.3455 2.07768 23.5 2.46667 23.5H3.86978M17.1333 0.5C16.5504 0.501805 15.9919 0.73417 15.5797 1.14636C15.1675 1.55855 14.9351 2.11708 14.9333 2.7V9.3M17.1333 0.5C17.7163 0.501548 18.275 0.733831 18.6873 1.14608C19.0995 1.55832 19.3318 2.117 19.3333 2.7V5.14444H14.9333M3.93333 5.14444H10.5333M3.93333 9.05556H7.21769M21.5332 18.9409L16.8526 19.8776M17.3171 14.5683L15.1074 15.5011C14.9331 15.5733 14.7459 15.6092 14.5573 15.6067C14.3687 15.6042 14.1826 15.5632 14.0103 15.4864C13.8357 15.4081 13.6783 15.2959 13.5472 15.1565C13.4162 15.017 13.314 14.853 13.2466 14.6739C13.1141 14.3334 13.1112 13.9561 13.2385 13.6137C13.3657 13.2712 13.6143 12.9874 13.937 12.8161L16.1458 11.7132C16.3848 11.59 16.6469 11.5182 16.9153 11.5024C17.1837 11.4866 17.4525 11.527 17.7043 11.6212L21.9041 13.5965M21.9041 13.5965C21.6843 13.7927 21.551 14.0678 21.5333 14.362V19.6009C21.551 19.895 21.6843 20.1702 21.9041 20.3664C22.1239 20.5626 22.4124 20.6639 22.7067 20.6481H23M21.9041 13.5965C22.1239 13.4003 22.4124 13.299 22.7067 13.3148H23M8.2844 19.9147H9.84884L12.8301 22.189C12.9695 22.3466 13.1647 22.4439 13.3745 22.4603C13.5843 22.4767 13.7923 22.411 13.9545 22.277L18.1199 18.8372C18.2845 18.701 18.3897 18.506 18.4132 18.2937C18.4367 18.0813 18.3768 17.8681 18.246 17.6991L15.9512 15.148M13.6973 12.9725L13.4558 12.7769C13.2161 12.6007 12.9354 12.4884 12.6403 12.4508C12.3452 12.4131 12.0453 12.4514 11.7691 12.5618L8.27843 14.0422M6.86667 20.6481H7.16C7.45422 20.6639 7.74274 20.5626 7.96256 20.3664C8.18239 20.1702 8.31568 19.895 8.33333 19.6009V14.362C8.31568 14.0678 8.18239 13.7927 7.96256 13.5965C7.74274 13.4003 7.45422 13.299 7.16 13.3148H6.86667",
				stroke: "#001489",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_7093_470184",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgAddDocumentIcon);
export default ForwardRef;
